export const HINTS = [
  {
    pre: 'Tell me about',
    posts: [
      'Hans Vestberg from Verizon',
      'the CEO of Verizon',
      'John Stankey from AT&T',
      'the CEO of AT&T',
      'Margherita Della Valle from Vodafone Group',
      'the CEO of Vodafone Group',
      'Allison Kirkby from BT Group',
      'the CEO of BT Group',
      'Christel Heydemann from Orange',
      'the CEO of Orange',
      'Sigve Brekke from Telenor',
      'the CEO of Telenor',
      'Tim Höttges from Deutsche Telekom',
      'the CEO of Deutsche Telekom',
      'Mike Sievert from T-Mobile US',
      'the CEO of T-Mobile US',
      'José María Álvarez-Pallete from Telefónica',
      'the CEO of Telefónica',
      'Gopal Vittal from Bharti Airtel',
      'the CEO of Bharti Airtel',
      'Ralph Mupita from MTN Group',
      'the CEO of MTN Group',
      'Shameel Joosub from Vodacom Group',
      'the CEO of Vodacom Group',
      'Yoo Young-sang from KT Corporation',
      'the CEO of KT Corporation',
      'Ryu Young-sang from SK Telecom',
      'the CEO of SK Telecom',
      'Hiroshi Mikitani from Rakuten Group',
      'the Chairman of Rakuten Group',
      'Mickey Mikitani from Rakuten Mobile',
      'the CEO of Rakuten Mobile',
      'Ke Ruiwen from China Telecom',
      'the Chairman and CEO of China Telecom',
      'Yang Jie from China Mobile',
      'the Chairman of China Mobile',
      'Lu Yimin from China Unicom',
      'the CEO of China Unicom',
      'Stephen Rue from NBN Co',
      'the CEO of NBN Co',
      'Ahmed Essam from Vodafone UK',
      'the CEO of Vodafone UK',
      'Vinod Kumar from Vodafone Business',
      'the CEO of Vodafone Business',
      'Börje Ekholm from Ericsson',
      'the CEO of Ericsson',
      'Pekka Lundmark from Nokia',
      'the CEO of Nokia',
      'Peng Song from Huawei Carrier Business',
      'the President of Huawei Carrier Business',

    ]
  },
  {
    pre: 'Create a report about',
    posts: [
      'Verizon',
      'AT&T',
      'BT Group',
      'Vodafone Group',
      'Vodafone Ireland',
      'Vodafone Germany',
      'Telenor',
      'Orange',
      'Orange Egypt',
      'Telefonica',
      'Movistar (Telefonica brand)',
      'O2 UK',
      'Deutsche Telekom',
      'T-Mobile US',
      'Telstra',
      'NBN Co (Australia)',
      'Reliance Jio',
      'Airtel India',
      'MyRepublic (Singapore)',
      'Singtel',
      'SK Telecom',
      'KT Corporation',
      'Rakuten Mobile',
      'Ericsson',
      'Nokia Networks',
      'Altice USA',
      'UScellular',
      'Telus',
      'Rogers Communications',
      'Bell Canada',
      'Etisalat',
      'du (EITC)',
      'Zain Group',
      'STC (Saudi Telecom Company)',
      'Ooredoo',
      'Omantel',
      'Batelco',
      'Tele2',
      'TDC Group',
      'Proximus',
      'Swisscom',
      'TIM (Telecom Italia)',
      'Claro',
      'Entel',
      'Digicel',
      'Liberty Global',
      'China Mobile',
      'China Unicom',
      'China Telecom',
    ]
  },
  {
    pre: 'Write a post about',
    posts: [
      'Digital transformation',
      'Customer experience',
      'Network evolution',
      '5G innovation',
      'Cloud adoption',
      'AI in telecom',
      'Telco agility',
      'Journey automation',
      'Platform modernization',
      'Billing simplicity',
      'Partner ecosystems',
      'Data monetization',
      'Service assurance',
      'Business growth',
      'Network intelligence',
      'CX personalization',
      'Open architecture',
      'Zero-touch ops',
      'Edge computing',
      'Agile delivery',
      'Smart networks',
      'Tech leadership',
      'Legacy modernization',
      'Real-time engagement',
      'Experience orchestration',
      'Digital onboarding',
      'Telco innovation',
      'Seamless operations',
      'Sustainability goals',
      'Network resilience',
      'Private 5G',
      'Telco cloud',
      'Customer insights',
      'B2B services',
      'Revenue growth',
      'Hyper-automation',
      'User expectations',
      'CX strategy',
      'Product innovation',
      'Future networks',
      'Intelligent systems',
      'Operational simplicity',
      'E2E journeys',
      'Data-driven CX',
      'Low-code platforms',
      'Network agility',
      'Experience design',
      'Scalability',
      'Core transformation',
      'Digital-first mindset',
    ]
  }
]

// Verizon
// AT&T
// BT Group
// Vodafone Group
// Vodafone Ireland
// Vodafone Germany
// Telenor
// Orange
// Orange Egypt
// Telefonica
// Movistar (Telefonica brand)
// O2 UK
// Deutsche Telekom
// T-Mobile US
// Telstra
// NBN Co (Australia)
// Reliance Jio
// Airtel India
// MyRepublic (Singapore)
// Singtel
// SK Telecom
// KT Corporation
// Rakuten Mobile
// Ericsson
// Nokia Networks
// Altice USA
// UScellular
// Telus
// Rogers Communications
// Bell Canada
// Etisalat
// du (EITC)
// Zain Group
// STC (Saudi Telecom Company)
// Ooredoo
// Omantel
// Batelco
// Tele2
// TDC Group
// Proximus
// Swisscom
// TIM (Telecom Italia)
// Claro
// Entel
// Digicel
// Liberty Global
// China Mobile
// China Unicom
// China Telecom

